import { Controller } from "@hotwired/stimulus";
import { hasSeenHint, requestCoachMark, withdrawCoachMark } from "../lib/coach_marks";

/**
 * Une bulle « première fois » (lib/coach_marks), déclarée là où elle s'applique : sa clé,
 * son ancre (un sélecteur), son texte. Elle se montre quand arrive l'événement qui la
 * déclenche, après un court délai — si elle n'a jamais été vue et si son ancre est visible.
 * Retirer le marqueur la retire (sans la compter comme vue).
 *
 * Usage :
 *   <span hidden data-controller="coach"
 *         data-coach-key-value="editor.group"
 *         data-coach-anchor-value="[data-tool-id='group']"
 *         data-coach-text-value="Groupez vos éléments ici"
 *         data-coach-dismiss-value="Compris"
 *         data-action="editor:multi-select@window->coach#trigger"></span>
 */
export default class extends Controller {
  static values = {
    key: String,
    anchor: String,
    text: String,
    placement: { type: String, default: "top" },
    dismiss: String,
    delay: { type: Number, default: 450 },
  };

  trigger() {
    if (this.timer || hasSeenHint(this.keyValue)) return;

    this.timer = setTimeout(() => {
      this.timer = null;
      requestCoachMark({
        key: this.keyValue,
        anchor: () => visible(document.querySelector(this.anchorValue)),
        text: this.textValue,
        placement: this.placementValue,
        dismissLabel: this.dismissValue || undefined,
      });
    }, this.delayValue);
  }

  disconnect() {
    clearTimeout(this.timer);
    this.timer = null;
    withdrawCoachMark(this.keyValue);
  }
}

/** L'ancre, si elle est à l'écran (un élément caché n'a pas de boîte). */
function visible(el) {
  return el && el.getClientRects().length > 0 ? el : null;
}
